<template>
  <section>
    <div class="progress-asessment">
      <div class="progress-bar-asessment">
        <span class="mr-2"
          >{{
            (100 / Math.ceil(data_questions.length / step)).toFixed(0)
          }}%</span
        >
        <b-progress
          class="mb-2"
          height="11px"
          variant="primary"
          :value="(100 / Math.ceil(data_questions.length / step)).toFixed(2)"
          :max="100"
        ></b-progress>
      </div>
    </div>
    <div
      class="row justify-content-center align-items-center"
      style="position: relative"
    >
      <div
        v-if="intro !== true"
        style="
          width: 30%;
          text-align: center;
          background: #b94039;
          color: #fff;
          font-family: Montserrat;
          font-style: normal;
          font-weight: bold;
          font-size: 26px;
          /* line-height: 32px; */
          text-align: center;
          color: #ffffff;
          padding: 0.5rem 1rem;
          border-radius: 0 0 8px 8px;
          margin-top: -21px;
        "
      >
        <vue-countdown-timer
          @end_callback="endCallBack('event ended')"
          :interval="1000"
          :start-time="startTime"
          :end-time="endTime"
          :end-text="'Ended'"
        >
          <template slot="countdown" slot-scope="scope">
            <h3 style="margin-bottom: 0; font-weight: 600">
              {{ (timeTracking.minutes = scope.props.minutes) }}:{{
                String(
                  parseInt((timeTracking.seconds = scope.props.seconds))
                ).padStart(2, "0")
              }}
            </h3>
          </template>
        </vue-countdown-timer>
      </div>
      <div class="col-md-12 body-element">
        <div v-for="(question, index) in data_questions">
          <!-- Hide all questions, show only the one with index === to current question index -->

          <div
            v-if="index === questionIndex && intro === true"
            class="answer-area"
          >
            <img
              :src="`https://redwhiteanalytics.com/${instruction.icon}`"
              class="img-fluid img-center"
              style="max-width: 20%"
            />
            <h6
              class="sub-head text-center"
              style="font-size: 1.3rem; margin-top: 1.5rem"
            >
              {{ instruction.title }}
            </h6>
            <p class="text-center question-intro-description">
              {{ instruction.description }} <br /><span
                v-html="totalQuestionIntro"
              ></span>
            </p>
          </div>

          <div
            v-else-if="
              index >= questionIndex &&
              index < questionIndex + show_question &&
              intro === false &&
              index !== 0
            "
          >
            <div class="quiestion-area" v-if="index === questionIndex">
              <h3 class="head-intro">{{ instruction.title }}</h3>
              <h5 class="question-head-bold" v-html="descQuestion"></h5>
            </div>
            <transition name="fade">
              <div class="container box-answer mb-4">
                <h3 class="question_desc">{{ question.text }}</h3>
                <div class="row">
                  <div class="col-4 col-md-4 col-sm-4 col-xs-4 mx-auto">
                    <div class="form-group">
                      <input
                        style="color: var(--theme-deafult)"
                        type="text"
                        name="code"
                        v-model="questionResponses[index]"
                        required="required"
                        class="text-center"
                      />
                      <i class="bar"></i>
                    </div>
                  </div>
                </div>
              </div>
            </transition>

            <div v-if="required === true" role="alert">
              <small class="text-muted danger-alert">
                <i class="fa fa-info-circle" style="margin-right: 5px"></i>
                {{ question.req_message }}
              </small>
              <br />
            </div>
          </div>
        </div>

        <div>
          <p v-if="intro !== true" class="text-center info-question">
            {{
              questionIndex + show_question - 1 >= totalQuestion - 1
                ? totalQuestion - 1
                : questionIndex + show_question - 1
            }}
            {{ instruction.lang == "id" ? " dari " : " out of " }}
            {{ totalQuestion - 1 }}
          </p>
          <div v-if="intro === true">
            <button
              type="button"
              v-on:click="nextIntro"
              class="btn btn-fill-center btn-lg btn-block"
            >
              {{ instruction.lang == "id" ? "Mulai" : "Start" }}
            </button>
          </div>
          <div v-else-if="questionIndex > 0">
            <button
              :disabled="loading"
              type="button"
              v-on:click="nextQuestion"
              class="btn btn-fill-center btn-lg btn-block"
            >
              <span v-if="loading == false">Next</span>
              <span
                v-else
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapActions, mapState } from "vuex";
  
  export default {
    name: "numerical",
    props: {
      section: {},
    },
    data() {
      return {
        timeTracking: {
          minute: 0,
          seconds: 0,
        },
        questions: [
          {
            text_head: "<span></span>",
            text_naration:
              "Pikirkan peristiwa-peristiwa yang pernah atau sedang Anda alami saat bekerja. Pilihlah alternatif jawaban yang paling menggambarkan kondisi Anda selama 4 minggu terakhir.",
            intro: true,
            responses: [],
          },
          {
            no: 1,
            text: "Saya umumnya menyadari bagaimana perasaan setiap orang tentang orang lain dalam lingkaran sosial saya",
            req_message: "Wajib dipilih",
            text_hint: "",
            intro: false,
            type: "radio",
            id: "question_1_",
            responses: [
              {
                text: "Ya",
                value: "tp",
              },
              {
                text: "Tidak",
                value: "jr",
              },
            ],
          },
          {
            no: 2,
            text: "Dalam 4 minggu terakhir, seberapa sering <b>Anda merasa cemas?</b>",
            req_message: "Wajib dipilih",
            text_hint: "",
            intro: false,
            type: "radio",
            id: "question_2_",
            responses: [
              {
                text: "Ya",
                value: "tp",
              },
              {
                text: "Tidak",
                value: "jr",
              },
            ],
          },
        ],
        required: false,
        loading: false,
      };
    },
    watch: {
      timeTracking: {
        handler() {
          this.setTimeTracking(this.timeTracking);
        },
        deep: true,
      },
    },
    computed: {
      //MENGAMBIL DATA OUTLETS DARI STATE OUTLETS
      ...mapState("numerical", {
        startTime: (state) => state.startTime,
        endTime: (state) => state.endTime,
        instruction: (state) => state.instruction,
        timeRunning: (state) => state.timeRunning,
        data_questions: (state) => state.questions,
        intro: (state) => state.intro,
        questionIndex: (state) => state.questionIndex,
        bar_active: (state) => state.bar_active,
        bar_visited: (state) => state.bar_visited,
        questionResponses: (state) => state.questionResponses,
        step: (state) => state.questionIndex,
        answerCheck: (state) => state.answerCheck,
        show_question: (state) => state.show_question,
      }),
      timeStartComputed() {
        return new Date(this.startTime);
      },
      timeEndComputed() {
        const now = new Date(this.startTime);
        return new Date(
          now.getTime() +
            1000 *
              (60 - this.timeRunning.seconds) *
              (30 - this.timeRunning.minute)
        );
      },
      totalQuestion() {
        return this.data_questions.length;
      },
      totalQuestionIntro() {
        if (this.instruction.lang == "id") {
          return (
            "<strong>Total : " +
            this.instruction.count_question +
            " Pertanyaan</strong>"
          );
        } else {
          return (
            "<strong>Total : " +
            this.instruction.count_question +
            " Questions</strong>"
          );
        }
      },
      descQuestion() {
        if (this.instruction.lang == "id") {
          return "Silahkan tulis jawaban Anda. Anda hanya perlu menjawab angka saja. Jika terdapat jawaban dengan angka desimal, gunakan <strong>tanda titik (.) sebagai pemisah</strong>. Contoh: 1.5";
        } else {
          return "Please write your answer. You only need to answer the numbers. If there is an answer with a decimal number, use <strong> period (.) As a separator </strong>. Example: 1.5";
        }
      },
    },
    async created() {
      //SEBELUM COMPONENT DI-LOAD, REQUEST DATA DARI SERVER
      // this.getQuestions({
      //     type : 'A',
      //     lang : localStorage.lang
      // })
      
    },
    methods: {
      endCallBack: function (x) {
        this.submitAnswer();
      },
      //MENGAMBIL FUNGSI DARI VUEX MODULE outlet
      ...mapActions("numerical", [
        "getQuestions",
        "nextIntro",
        "next",
        "setTimeTracking",
        "submitAnswer",
      ]),
      nextQuestion: function () {
        this.loading = true;
        setTimeout(() => {
          this.next();
          this.loading = false;
        }, 750);
      },
    },
  };
</script>

<style>
.custom-control-input {
  min-height: 0 !important;
  opacity: 1 !important;
  z-index: 99 !important;
  left: 1rem !important;
}
input[type="radio"] {
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  min-height: 0;
  border-radius: 50%;
  outline: none;
  border: 2px solid #424043;
  margin: 0.85rem 0 !important;
}

/* The container */
.container-radio {
  width: 100%;
  display: block;
  cursor: pointer;
  margin-bottom: 1rem;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: relative;
}

input[type="radio"]:before {
  content: "";
  display: block;
  width: 12px;
  height: 12px;
  margin: 2px auto;
  border-radius: 50%;
  color: ;
}

input[type="radio"]:checked:before {
  background: var(--theme-deafult);
}

input[type="radio"]:checked {
  border-color: var(--theme-deafult);
}

input[type="radio"],
input[type="checkbox"] {
  box-sizing: border-box;
  padding: 0;
}
/* Create a custom radio button */
.checkmark-outline {
  padding: 0.8rem 3rem;
  width: 100%;
  background-color: #fff;
  display: block;
  text-align: left;
  font-size: 0.7em;
  margin: 0;
  border-radius: 0.3rem;
  border: 2px solid #424043;
  font-family: Rubik;
  font-style: normal;
  font-weight: 500;
  line-height: 17px;
  color: #424043;
}

.checkmark-outline:hover {
  color: var(--theme-deafult);
  border: 2px solid var(--theme-deafult);
  transition: 0.2s;
}

/* When the radio button is checked, add a blue background */
input:checked ~ .checkmark-outline {
  color: var(--theme-deafult);
  border: 2px solid var(--theme-deafult);
}

input[type="radio"]:hover {
  border: 2px solid var(--theme-deafult);
}

/* When the radio button is checked, add a blue background */
input:checked ~ span#loading {
  display: inline;
  position: absolute;
  z-index: 999;
  right: 5%;
  top: 25%;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark-outline:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.container input:checked ~ .checkmark-outline:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.container .checkmark-outline:after {
  top: 9px;
  left: 9px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  opacity: 0;
}

.label-language {
  font-family: Rubik;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 165%;
  /* identical to box height, or 40px */

  text-align: center;

  /* Grey/grey */

  color: #424043;
  margin-top: 30%;
}
.assesment-radio .checkmark-outline {
  padding: 1.2rem 3rem !important;
  font-size: 0.9rem;
  color: var(--theme-deafult);
}
</style>

<style scoped>
.box-answer {
  border: 2px solid var(--theme-deafult);
  box-shadow: 0px 0px 30px rgb(0 0 0 / 10%);
  border-radius: 6px;
  padding-bottom: 1rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.container_bar {
  width: 100%;
  height: 100%;
}
svg {
  margin: 0 auto;
  width: 80%;
  height: 90%;
  fill: none;
  stroke: var(--theme-deafult) !important;
  stroke-width: 10;
  stroke-linecap: round;
  -webkit-filter: drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.2));
  filter: drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.2));
}

.svg-result {
  margin: 0 auto;
}
.number-result {
  margin-top: -4.5rem;
}

.number-result h4 {
  font-family: "Lato", sans-serif !important ;
  font-size: 2.5rem;
  font-weight: 600;
  color: #2d3436;
}

.number-result h5 {
  font-family: "Lato", sans-serif !important ;
  font-size: 1.5rem;
}

.chart-result {
  margin: 1.5rem auto;
}

.question-head-bold {
  color: #2d3436;
  font-family: "Montserrat", sans-serif !important;
  font-size: 1rem;
  line-height: 1.5rem;
  margin-top: 0.2rem;
  font-weight: 500;
  text-align: center;
}

@media only screen and (max-width: 1024px) {
  .number-result h4 {
    font-size: 3rem;
  }
}

@media only screen and (max-width: 1440px) {
  .number-result h4 {
    font-size: 3.7rem;
  }
}

@media only screen and (max-width: 768px) {
  .number-result h4 {
    font-size: 2.5rem;
  }
}

@media only screen and (max-width: 586px) {
  .number-result h4 {
    font-size: 4rem;
  }
}

@media only screen and (max-width: 425px) {
  .number-result h4 {
    font-size: 3rem;
  }
}

@media only screen and (max-width: 375px) {
  .number-result h4 {
    font-size: 2.8rem;
  }
}

@media only screen and (max-width: 320px) {
  .number-result h4 {
    font-size: 2.2rem;
  }

  .number-result h5 {
    font-size: 1.4rem;
  }
}

/* To All page */
body {
  background: #fff;
  font-family: "Lato", sans-serif;
  color: #888;
}

p {
  font-size: 0.9rem;
}

nav {
  padding: 1rem 1rem !important;
  background: var(--theme-deafult);
}

input {
  min-height: 40px;
}
small {
  margin-bottom: 10px;
  font-size: 0.9em;
}
.label-input {
  margin-bottom: 0px;
  font-size: 1.4em;
  line-height: 1.2;
  font-weight: 400;
}

label.label-input.required:after {
  content: "*";
  color: red;
}
.body-survey {
  padding: 0.5rem 1.7rem;
}
/* Custome Navbar */
.navbar-brand {
  color: #f8f9fa;
}

/* Custome Tag H */
.h7-custome {
  color: #feeb23;
  font-weight: 700;
}

/* Button Custome */
.btn-fill-center {
  color: #fff;
  background-color: var(--theme-deafult);
  border-color: var(--theme-deafult);
  width: 30% !important;
  margin: 0.5rem auto !important;
  padding: 7px 10px;
  font-weight: 600;
  font-size: 0.9rem;
  border-radius: 4px;

  border-width: 2px;
  transition: 0.1s;
  font-family: "Montserrat", sans-serif !important;
  font-style: normal;
}
@media (max-width: 468px) {
  .btn-fill-center {
    width: 50% !important;
  }
}
.btn-outfill {
  border: 0.1rem solid var(--theme-deafult);
  background: transparent;
  color: var(--theme-deafult);
  padding: 0.7rem 15%;
  font-weight: 500;
  font-size: 0.9rem;
}
.btn-outfill:focus,
.btn-outfill:hover {
  background: var(--theme-deafult);
  color: #fff;
}

.btn-fill {
  border: 0.1rem solid var(--theme-deafult);
  background: var(--theme-deafult);
  color: #fff;
  padding: 0.7rem 15%;
  font-weight: 500;
  font-size: 0.9rem;
}
.btn-fill:focus,
.btn-fill:hover {
  background: transparent;
  color: var(--theme-deafult);
}

/* Element Question */
.quiestion-area {
  margin-bottom: 1.5rem;
}
.answer-area {
  margin-bottom: 0.6rem;
}
.rekomendasi-area {
  padding: 1rem;
}

.rekomendasi-area h5 {
  font-weight: 600;
}

.rekomendasi-area p {
  margin: 0;
  color: #555;
  font-size: 0.9rem;
  margin-bottom: 0.8rem;
}
/* Text Question */
.head-intro {
  font-weight: 600;
  color: #2d3436;
  margin: 0;
  font-family: "Montserrat", sans-serif !important;
  font-size: 1.2rem;
  line-height: 1.5rem;
  text-align: center;
}
/*.head-intro:after {*/
/*    content: "";*/
/*    display: block;*/
/*    width: 30%;*/
/*    margin: 0 auto;*/
/*    margin-top: 1rem;*/
/*    border-bottom: 4px solid var(--theme-deafult);*/
/*}*/

.text-description {
  color: #000;
  font-size: 0.9rem !important;
  font-weight: 400;
  line-height: 25px;
}

.question-head,
.question-intro-head {
  color: #424043;
  margin-top: 1rem;
  font-family: "Lato", sans-serif !important;
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.5rem;
}

.question-intro-head {
  font-size: 1.2rem;
}

.question-intro-description-dr {
  color: #555;
  font-size: 1.1rem;
}

.question-intro-description {
  font-size: 1.1rem;
  color: #2d3436;
  padding: 0 1rem;
}

.text-header-desciption {
  color: #555;
  margin-bottom: 1rem;
  font-size: 0.9rem;
  line-height: 21px;
  font-weight: 500;
  font-family: "Lato", sans-serif !important;
}

.info-question {
  margin: 0.3rem auto;
  font-weight: 500;
  font-size: 14px;
  font-family: "Montserrat", sans-serif !important;
  text-align: center;

  color: #292929;
}

/* Image Custome */
.img-center {
  display: block;
  margin: 1.5em auto;
  width: 100%;
  max-width: 50%;
}

/* Custome Text */
.lead {
  font-size: 1.1rem;
}

/* To Element question & answer */
.body-element {
  padding: 5% 10%;
}

/* When the radio button is checked, add a blue background */
input:checked ~ .checkmark-outline {
  /* color: #222023;
  border: 2px solid var(--theme-deafult); */
}

input[type="radio"]:hover {
  border: 2px solid var(--theme-deafult);
}

/* When the radio button is checked, add a blue background */
input:checked ~ span#loading {
  display: inline;
  position: absolute;
  z-index: 999;
  right: 5%;
  top: 25%;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark-outline:after {
  content: "";
  position: absolute;
  display: none;
}

/* Custome card */
.card,
.card-header {
  background: #f2f2f2;
  opacity: 0.7;
}

.card-header {
  color: #333;
}

.card-body {
  color: #333;
}

.custom-control {
  position: relative;
  display: block;
  min-height: 1.5rem;
  padding-left: 0;
}

/* Custome Input */
.form-control {
  opacity: 1 !important;
  border: 1px solid var(--theme-deafult);
  padding: 0.8rem 1.4rem;
  height: 100% !important;
  width: 100% !important;
  font-size: 0.9rem;
}

/* Create a custom radio button */
.checkmark {
  text-transform: capitalize;
  padding: 0.5rem;
  height: 100%;
  width: 100%;
  background-color: #f8ecec;
  color: #b9403a;
  display: inline-block;
  text-align: center;
  font-size: 0.9rem;
  margin: 0;
  border-radius: 0.5rem;
  border: 1px solid var(--theme-deafult);
}

.checkmark:hover {
  background-color: #b9403a;
  color: #fff;
  border: 1px solid #fff;
  transition: 0.1s;
}
.check-disable {
  background: #d4d2d2 !important;
  cursor: not-allowed;
  color: #424043 !important;
}
.check-selected {
  background: #b9403a !important;
  color: #fff !important;
}

/* When the radio button is checked, add a blue background */
input:checked ~ .checkmark {
  background-color: #b9403a !important;
  color: #ffffff !important;
  border: 1px solid #b9403a !important;
}

/* When the radio button is checked, add a blue background */
input:checked ~ span#loading {
  display: inline;
  position: absolute;
  z-index: 999;
  right: 5%;
  top: 25%;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.container .checkmark:after {
  top: 9px;
  left: 9px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  opacity: 0;
}

/* Pagination Bar */
.pagination {
  padding: 0;
  margin: 0 0 0.8rem 0;
}

.pagination ul {
  width: 100%;
  margin: 0 auto;
  padding: 0;
  text-align: left;
  list-style-type: none;
  display: flex;
  margin-top: 1rem;
}

.pagination a {
  display: inline-block;
  padding: 10px 10px;
  color: #222;
}

.p5 a {
  width: 4% !important;
  border-radius: 10px;
  height: 5px;
  padding: 0;
  margin: auto 0.5%;
  background-color: #fabcaa;
  flex: 1;
}

.p5 .is-active {
  border-radius: 10px;
  background-color: var(--theme-deafult);
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);
}
.p5 .is-active-visited {
  box-shadow: none;
}

.sub-head {
  color: var(--theme-deafult);
  font-family: "Lato", sans-serif !important;
  font-weight: 600;
  font-size: 0.9rem;
}

.text-muted {
  font-size: 0.8rem;
  font-weight: 500;
}
progress,
progress[role] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: none;
  background-size: auto;
  height: 40px;
  width: 100%;
}

.result {
  color: #feeb3e;
  border: 4px solid #feeb3e;
  padding: 10px;
}

.button-group-bottom {
  position: fixed;
  width: 100%;
  bottom: 1rem;
}

.progress-bar {
  background-color: var(--theme-deafult);
  font-size: 1.5rem;
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.2), 0 5px 5px rgba(0, 0, 0, 0.05);
}

.alert-outline-danger {
  border: 0.15rem solid #bd2130;
  color: #bd2130;
}

.result-hide {
  position: fixed;
  display: none;
}

.result-show {
  display: block;
}
.datepicker {
  background-color: #fff !important;
}
/* ###### 3.2 Datepicker ###### */
.ui-datepicker {
  background-color: #fff;
  border: 1px solid rgba(72, 94, 144, 0.16);
  font-family: inherit;
  font-size: inherit;
  padding: 10px;
  margin: 1px 0 0;
  display: none;
  width: auto !important;
  z-index: 5 !important;
  border-radius: 0.25rem;
}
.ui-datepicker .ui-datepicker-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  color: #001737;
  padding: 0 0 5px;
  letter-spacing: 1px;
  border: 0;
  background-color: transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.ui-datepicker .ui-datepicker-header .ui-datepicker-next,
.ui-datepicker .ui-datepicker-header .ui-datepicker-prev {
  text-indent: -99999px;
  color: #8392a5;
  top: 0;
}
.ui-datepicker .ui-datepicker-header .ui-datepicker-next::before,
.ui-datepicker .ui-datepicker-header .ui-datepicker-prev::before {
  font-size: 16px;
  font-family: "Ionicons";
  position: absolute;
  top: -1px;
  text-indent: 0;
}
.ui-datepicker .ui-datepicker-header .ui-datepicker-next:hover::before,
.ui-datepicker .ui-datepicker-header .ui-datepicker-next:focus::before,
.ui-datepicker .ui-datepicker-header .ui-datepicker-prev:hover::before,
.ui-datepicker .ui-datepicker-header .ui-datepicker-prev:focus::before {
  color: #1b2e4b;
}
.ui-datepicker .ui-datepicker-header .ui-datepicker-next {
  order: 3;
}
.ui-datepicker .ui-datepicker-header .ui-datepicker-next:before {
  right: 5px;
  content: "\f3d1";
}
.ui-datepicker .ui-datepicker-header .ui-datepicker-prev:before {
  left: 5px;
  content: "\f3cf";
}
.ui-datepicker .ui-datepicker-header .ui-datepicker-next-hover,
.ui-datepicker .ui-datepicker-header .ui-datepicker-prev-hover {
  color: #1b2e4b;
  cursor: pointer;
  top: 1px;
  border: 0;
  background-color: transparent;
}
.ui-datepicker .ui-datepicker-title {
  color: #001737;
  font-weight: 700;
  font-size: 13px;
}
.ui-datepicker select.ui-datepicker-month,
.ui-datepicker select.ui-datepicker-year {
  font-size: 11px;
  border: 1px solid #c0ccda;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 2px 20px 2px 5px;
  border-radius: 0.25rem;
  position: relative;
  margin-top: -3px;
  background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%233b4863' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e")
    no-repeat right 5px center/8px 8px;
}
.ui-datepicker .ui-datepicker-year {
  margin-left: 5px;
}
.ui-datepicker .ui-datepicker-calendar {
  margin: 0;
  background-color: transparent;
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.ui-datepicker .ui-datepicker-calendar th {
  text-transform: uppercase;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1px;
  padding: 6px 9px;
  color: #1b2e4b;
}
@media (max-width: 320px) {
  .ui-datepicker .ui-datepicker-calendar th {
    padding: 4px 0;
    letter-spacing: normal;
  }
}
.ui-datepicker .ui-datepicker-calendar td {
  border: 1px solid #fff;
  padding: 0;
  background-color: #fff;
  text-align: right;
}
.ui-datepicker .ui-datepicker-calendar td:last-child {
  border-right: 0;
}
.ui-datepicker
  .ui-datepicker-calendar
  td.ui-datepicker-other-month
  .ui-state-default {
  color: #c0ccda;
}
.ui-datepicker .ui-datepicker-calendar td span,
.ui-datepicker .ui-datepicker-calendar td a {
  transition: all 0.2s ease-in-out;
  padding: 5px;
  color: #1b2e4b;
  padding: 6px 10px;
  display: block;
  font-weight: 400;
  font-size: 12px;
  border: 0;
  border-radius: 1px;
}
@media (prefers-reduced-motion: reduce) {
  .ui-datepicker .ui-datepicker-calendar td span,
  .ui-datepicker .ui-datepicker-calendar td a {
    transition: none;
  }
}
.ui-datepicker .ui-datepicker-calendar td a:hover {
  background-color: #fff;
  color: #001737;
}
.ui-datepicker .ui-datepicker-calendar .ui-datepicker-today a,
.ui-datepicker .ui-datepicker-calendar .ui-datepicker-today a:hover,
.ui-datepicker .ui-datepicker-calendar .ui-datepicker-today a:focus {
  background-color: #0168fa;
  color: #fff;
}
.ui-datepicker .ui-datepicker-calendar .ui-state-disabled .ui-state-default {
  color: #c0ccda;
  background-color: #f5f6fa;
}

.ui-datepicker-multi .ui-datepicker-group {
  padding-right: 15px;
  width: auto;
  float: left;
}
.ui-datepicker-multi .ui-datepicker-group .ui-datepicker-title {
  margin: auto;
}
.ui-datepicker-multi .ui-datepicker-group .ui-datepicker-prev::before {
  left: 10px;
}
.ui-datepicker-multi .ui-datepicker-group .ui-datepicker-next::before {
  right: 10px;
}
.ui-datepicker-multi .ui-datepicker-group table {
  margin: 0;
}

.ui-datepicker-multi .ui-datepicker-group-last {
  padding-right: 0;
}

.ui-datepicker-inline {
  border-color: #c0ccda;
}
@media (min-width: 576px) {
  .ui-datepicker-inline {
    max-width: 270px;
  }
}

.ui-datepicker-buttonpane {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  border-top: 1px solid #e5e9f2;
  padding-top: 10px;
}
.ui-datepicker-buttonpane button {
  min-height: inherit;
  border-radius: 0.25rem;
}

.legendColorBox > div {
  border: 0 !important;
  padding: 0 !important;
  border-radius: 100%;
  overflow: hidden;
}

.legendLabel {
  font-size: 10px;
  font-weight: 500;
  color: #8392a5;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  text-transform: uppercase;
  padding-left: 5px;
}

/* ###### 4.3 jQuery Steps ###### */

/* Circle Load */
#loading {
  display: none;
}
.ouro {
  position: relative;
  display: inline-block;
  height: 26px;
  width: 26px;
  border-radius: 50%;
  background: none repeat scroll 0 0 var(--theme-deafult);
  overflow: hidden;
}

.ouro:after {
  content: "";
  position: absolute;
  top: 9px;
  left: 9px;
  display: block;
  height: 8px;
  width: 8px;
  background: none repeat scroll 0 0 var(--theme-deafult);
  border-radius: 50%;
}
.ouro > span {
  position: absolute;
  height: 100%;
  width: 50%;
  overflow: hidden;
}
.left {
  left: 0;
}
.right {
  left: 50%;
}

.anim {
  position: absolute;
  left: 100%;
  top: 0;
  height: 100%;
  width: 100%;
  border-radius: 999px;
  background: none repeat scroll 0 0 #fff;
  opacity: 0.8;
  -webkit-animation: ui-spinner-rotate-left 3s;
  animation: ui-spinner-rotate-left 3s;
  -webkit-transform-origin: 0 50% 0;
  transform-origin: 0 50% 0;
}
.left .anim {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}
.right .anim {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  left: -100%;
  -webkit-transform-origin: 100% 50% 0;
  transform-origin: 100% 50% 0;
}

/* v3 */
.ouro3 .anim {
  -webkit-animation-delay: 0s;
  -webkit-animation-duration: 2s;
  -webkit-animation-timing-function: linear;
  animation-delay: 0s;
  animation-duration: 1.5s;
  animation-timing-function: linear;
}
.ouro3 .right .anim {
  -webkit-animation-name: ui-spinner-rotate-right;
  -webkit-animation-delay: 0;
  -webkit-animation-delay: 0s;
  animation-name: ui-spinner-rotate-right;
  animation-delay: 0;
  animation-delay: 0s;
}

/* round variation */
.round .ouro:after {
  display: none;
}

/* double variation */
.double .ouro:after {
  height: 13px;
  width: 13px;
  left: 7px;
  top: 7px;
  border: 10px solid #ddd;
  background: transparent;
  box-shadow: none;
}

@keyframes ui-spinner-rotate-right {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(180deg);
  }
  50% {
    transform: rotate(180deg);
  }
  75% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes ui-spinner-rotate-left {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  75% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes ui-spinner-rotate-right {
  0% {
    -webkit-transform: rotate(0deg);
  }
  25% {
    -webkit-transform: rotate(180deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
  }
  75% {
    -webkit-transform: rotate(360deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@-webkit-keyframes ui-spinner-rotate-left {
  0% {
    -webkit-transform: rotate(0deg);
  }
  25% {
    -webkit-transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
  }
  75% {
    -webkit-transform: rotate(180deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

.danger-info {
  border: 1px solid #f74040;
}

.danger-alert {
  color: #f74040 !important;
  font-size: 0.7rem;
}

.btn-fill-center:hover {
  background-color: #f8f9fa;
  border-color: var(--theme-deafult) !important;
  color: var(--theme-deafult);
  border-width: 2px;
}

.header-result {
  color: var(--theme-deafult);
  font-weight: 600;
  padding: 0.5rem;
  border-left: 0.5rem solid var(--theme-deafult);
  margin-bottom: 1rem;
}

.desc-result {
  font-family: Lato !important;
  font-style: normal;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.5rem;
  text-align: left;
  color: #424043;
  padding-left: 1rem;
}

.label-radio-btn {
  font-family: Rubik;
  font-style: normal;
  font-weight: 500;
  font-size: 0.9rem;
  color: #b9403a;
  line-height: 170%;
}

.rdiobox input[type="radio"]:checked + span:before {
  border-color: #b9403a;
  background-color: #fff;
}
.rdiobox span {
  padding-left: 30px;
  display: block;
}
.rdiobox span:after {
  content: "";
  width: 14px;
  height: 14px;
  background-color: #b9403a;
  border-radius: 50px;
  top: 6px;
  left: 4px;
  display: none;
  margin-top: -0.1rem;
}
.rdiobox {
  margin-bottom: 0 !important;
}
.rdiobox span:before {
  margin-top: -0.1rem;
  content: "";
  width: 22px;
  height: 22px;
  background-color: #fff;
  border: 2px solid #b9403a;
  border-radius: 50px;
  top: 2px;
  left: 0;
}

.form-group input {
  height: 1.9rem;
}

.form-group input[type="file"] {
  line-height: 1;
}
.form-group input[type="file"] ~ .bar {
  display: none;
}
.form-group select,
.form-group input:focus,
.form-group input:valid,
.form-group input.form-file,
.form-group input.has-value,
.form-group textarea:focus,
.form-group textarea:valid,
.form-group textarea.form-file,
.form-group textarea.has-value {
  color: #333;
}
.form-group select ~ .control-label,
.form-group input:focus ~ .control-label,
.form-group input:valid ~ .control-label,
.form-group input.form-file ~ .control-label,
.form-group input.has-value ~ .control-label,
.form-group textarea:focus ~ .control-label,
.form-group textarea:valid ~ .control-label,
.form-group textarea.form-file ~ .control-label,
.form-group textarea.has-value ~ .control-label {
  font-size: 0.8rem;
  color: gray;
  top: -1rem;
  left: 0;
}
.form-group select:focus,
.form-group input:focus,
.form-group textarea:focus {
  outline: none;
}
.form-group select:focus ~ .control-label,
.form-group input:focus ~ .control-label,
.form-group textarea:focus ~ .control-label {
  color: #337ab7;
}
.form-group select:focus ~ .bar::before,
.form-group input:focus ~ .bar::before,
.form-group textarea:focus ~ .bar::before {
  width: 100%;
  left: 0;
}
.form-group input::placeholder {
  font-family: Rubik;
  font-style: italic;
  font-weight: 500;
  font-size: 14px;
  line-height: 165%;
  color: #828282;
}
.form-group input,
.form-group textarea {
  display: block;
  background: none;
  padding: 0.125rem 0.125rem 0.0625rem;
  border-width: 0;
  border-color: transparent;
  width: 100%;
  transition: all 0.28s ease;
  box-shadow: none;
  font-family: Rubik;
  font-weight: 500;
  font-size: 1rem;
  line-height: 165%;
  color: #828282;
}

.form-group .bar {
  margin-top: 0.6rem;
  position: relative;
  border-bottom: 2px solid #fabcaa;
  display: block;
}
.form-group .bar::before {
  content: "";
  height: 2px;
  width: 0;
  left: 50%;
  bottom: -0.0625rem;
  position: absolute;
  background: var(--theme-deafult);
  -webkit-transition: left 0.28s ease, width 0.28s ease;
  transition: left 0.28s ease, width 0.28s ease;
  z-index: 2;
}
.question_desc {
  text-align: center;
  font-family: Rubik;
  font-style: normal;
  font-weight: 500;
  font-size: 1rem;
  line-height: 150%;
  color: #000;
  margin: 1rem 0;
}

.text-comunication {
  font-family: Rubik;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 150%;
  color: #424043;
}

.block-think {
  width: 15%;
}
@media (max-width: 600px) {
  .text-description {
    text-align: center;
  }
  .section_c {
    padding: 0.5rem 2rem;
  }
  .question-intro-description {
    font-size: 1rem;
  }
  .sub-head {
    font-size: 1.2rem !important;
  }
  .question_desc {
    font-size: 0.9rem;
  }
  .social-option {
    left: 30%;
  }
  .question-head-bold {
    font-size: 0.9rem;
  }

  .az-profile-menu.show .dropdown-menu {
    height: 100vh;
  }
  .block-think {
    width: 17%;
  }
  .header-finis {
    font-size: 1.5rem !important;
  }
  .desc-finis {
    font-size: 0.8rem !important;
    padding: 0 1rem !important;
  }
}

.head-intro {
  margin-bottom: 0.5rem;
}

.box-ans {
  background: #f8ecec;
  padding: 0.5rem 1rem;
  border-radius: 2rem;
  margin-bottom: 1rem;
}
</style>

<style lang="scss">
.detail-assessment {
  .header-asessment {
    padding: 1.5rem 2rem;
    width: 80%;
    margin: 0 auto;
    img {
      width: 100%;
    }

    .wording {
      align-self: center;
      h3 {
        color: var(--theme-deafult);
      }
    }
  }
  .progress-asessment {
    background-color: #f5f5f5;
    padding: 0.7rem 1rem;

    .progress-bar-asessment {
      width: 80%;
      margin: 0 auto;
      display: flex;

      span {
        font-weight: 500;
      }

      .progress {
        width: 100%;
        align-self: center;
        margin-bottom: 0 !important;
        border-radius: 1rem !important;
        .progress-bar {
          border-radius: 1rem;
        }
      }
    }
  }

  .question-asessment {
    min-height: 500px;
  }
}
</style>
